import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import React from 'react';

import styles from './styles.module.scss';

type TabItem = {
  label: string;
  value: string;
};

type ProfileCommonHeaderProps = {
  currentTab: string;
  setCurrentTab: React.Dispatch<React.SetStateAction<string>>;
  tabs: TabItem[];
};

const ProfileCommonHeader = ({ currentTab, setCurrentTab, tabs }: ProfileCommonHeaderProps): JSX.Element => {
  const handleChange = (event: React.SyntheticEvent, newValue: string): void => {
    setCurrentTab(newValue);
    window.location.hash = newValue;
  };

  return (
    <div className={styles.profileCommonHeaderDiv}>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={currentTab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="tab navigation">
              {tabs.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
              ))}
            </TabList>
          </Box>
        </TabContext>
      </Box>
    </div>
  );
};

export default ProfileCommonHeader;
